import TabHeader from "../../tab/TabHeader";
import FlagsDetails from "./FlagsDetails";

export default function FlagsTab() {   

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Flags</h2>
            </div>            
        </TabHeader>
       <FlagsDetails />
       
    </>
}